module.exports = __webpack_public_path__ + "media/icons/naped-przod-blue-98eab8af.png";